import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyDashboardsMessage: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.empty-content.empty-dashboards-message',
		defaultMessage: 'Once you visit or create dashboards, they’ll show up here.',
		description: 'A message that gets displayed when the dashboards menu is empty',
	},
});
